import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { plainToClass } from 'class-transformer';
import { GeneralInfo } from 'app/shared/models/general-info.model';
import { EntityType } from 'app/shared/models/entity-id-details.model';

/**
 * Service for General Information Details card.
 */
@Injectable()
export class GeneralInformationService {

    constructor(private requestService: ObservableRequestService) { }

    getGeneralInfoDesc(id: number, entityType: EntityType): Observable<any> {
        return this.requestService.getRequest(
            `${(entityType.toString().toLowerCase() === 'person' ?
                ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
                ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES)}/${id}`
        ).map(response => {
            return plainToClass(GeneralInfo, response.arrResult as Object[]);
        });
    };

    updateGeneralInformationDescription(generalInfoTextSaveData: GeneralInfo, entityType: string): Observable<any> {
        const generalInfoSavePath = (entityType.toLocaleLowerCase() === 'person') ?
                                    ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
                                    ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES;
        return this.requestService.putRequest(generalInfoSavePath,
            JSON.stringify(generalInfoTextSaveData),
            this.requestService.getJSONContentType());
    };
}


// WEBPACK FOOTER //
// ./src/app/entities/details/generalinformation/general-information.service.ts